import { FromUnitInput, InputField, ToUnitInput } from "../types";

export default function getConfig(
  configs: InputField[],
  fromUnitInput: FromUnitInput,
  toUnitInput: ToUnitInput
): InputField | undefined {
  return configs.find((x) => {
    const hasToMassUnit =
      x.toMassUnit === undefined ||
      (x.toMassUnit.numeratorUnitId === toUnitInput?.massUnit.numeratorUnitId &&
        x.toMassUnit.denominatorUnitId === toUnitInput?.massUnit.denominatorUnitId);

    return x.fromUnitIds.includes(fromUnitInput?.declaredUnitId) && x.toUnitId === toUnitInput?.declaredUnitId && hasToMassUnit;
  });
}
